import React from "react";

export default function DisfagiaFarmacos() {
  const pdfPath = "/docs/guia-para-administracion-medicamentos-pacientes-problemas-deglucion.pdf";

  return (
    <div className="p-4 max-w-xl mx-auto flex flex-col gap-4">

      {/* Encabezado */}
      <div className="flex items-center justify-center">
        <h3 className="font-bold text-center">DISFAGIA Y FÁRMACOS</h3>
      </div>

      {/* Introducción */}
      <div className="text-justify">
        <p className="mb-4">Agradecimientos a Dra. Elena Gómez y Dra.Lucía Ordóñez, farmacéuticas del H.U. Central de Asturias, 
          así como al Dr. José María Barroso, coordinador de la unidad de disfagia del H.U. Central de Asturias el uso de su 
          guía de administración de medicamentos para pacientes con disfagia (uso exclusivo vía oral) para el apartado de 
          disfagia y fármacos.
        </p>

        <p>Para buscar dentro del PDF en ordenador pulsa Ctrl/Cmd + F.</p>
      </div>

      <div style={{ marginTop: 16, height: "80vh", border: "1px solid #ddd", borderRadius: 8, overflow: "hidden" }}>
        <iframe
          title="Guía - Disfagia y Fármacos"
          src={pdfPath}
          style={{ width: "100%", height: "100%" }}
        />
      </div>

      {/* Texto + descargable */}
      <div className="flex items-center">
        <p className="text-justify gap-4 mt-2 mb-4">
          Si desea obtener el descargable, pulse en el siguiente{" "}
          <a
            href="/docs/guia-para-administracion-medicamentos-pacientes-problemas-deglucion.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline"
          >
            enlace
          </a>
          .
        </p>
      </div>
    </div>
  );
}